/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Status_Starting_ExportInputs */

const en_ateliere_connect_status_starting_export = /** @type {(inputs: Ateliere_Connect_Status_Starting_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting export...`)
};

const fr_ateliere_connect_status_starting_export = /** @type {(inputs: Ateliere_Connect_Status_Starting_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrage de l’exportation...`)
};

const de_ateliere_connect_status_starting_export = /** @type {(inputs: Ateliere_Connect_Status_Starting_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export wird gestartet...`)
};

const it_ateliere_connect_status_starting_export = /** @type {(inputs: Ateliere_Connect_Status_Starting_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio esportazione...`)
};

const ru_ateliere_connect_status_starting_export = /** @type {(inputs: Ateliere_Connect_Status_Starting_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начало экспорта...`)
};

const es_ateliere_connect_status_starting_export = /** @type {(inputs: Ateliere_Connect_Status_Starting_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando exportación...`)
};

const zh_cn2_ateliere_connect_status_starting_export = /** @type {(inputs: Ateliere_Connect_Status_Starting_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始导出...`)
};

const ja_ateliere_connect_status_starting_export = /** @type {(inputs: Ateliere_Connect_Status_Starting_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートを開始しています...`)
};

const hi_ateliere_connect_status_starting_export = /** @type {(inputs: Ateliere_Connect_Status_Starting_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात शुरू हो रहा है...`)
};

const pt_pt2_ateliere_connect_status_starting_export = /** @type {(inputs: Ateliere_Connect_Status_Starting_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando a exportação...`)
};

/**
* | output |
* | --- |
* | "Starting export..." |
*
* @param {Ateliere_Connect_Status_Starting_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_starting_export = /** @type {((inputs?: Ateliere_Connect_Status_Starting_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Starting_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_status_starting_export(inputs)
	if (locale === "de") return de_ateliere_connect_status_starting_export(inputs)
	if (locale === "it") return it_ateliere_connect_status_starting_export(inputs)
	if (locale === "ru") return ru_ateliere_connect_status_starting_export(inputs)
	if (locale === "es") return es_ateliere_connect_status_starting_export(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_status_starting_export(inputs)
	if (locale === "ja") return ja_ateliere_connect_status_starting_export(inputs)
	if (locale === "hi") return hi_ateliere_connect_status_starting_export(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_status_starting_export(inputs)
	return en_ateliere_connect_status_starting_export(inputs)
});